import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import ImageWithQuote from "./ImageWithQuote"
import Carousel from './Carousel'
import CentredContentContainer from '../Widgets/CentredContentContainer'

class ImageWithQuoteCarousel extends PureComponent {
    render() {
        const {classes, item} = this.props;

        return (
            <CentredContentContainer size="large">
                <Carousel
                    prevNextContainer={props => <div className={classes.carouselPrevNextContainer}>{props.children}</div>}
                    items={item.items.map((x, i) => (<div key={i} className={classes.flickityCell}><ImageWithQuote item={x} /></div>))}>
                </Carousel>
            </CentredContentContainer>
        )
    }
}

export default injectSheet((theme) => ({
    flickityCell: {
        width: '100%',
        marginRight: 20
    },
    carouselPrevNextContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: ({item: {items}}) => !items[0].image_size ? 0 : `0 ${theme.spacing.small}`,
        [theme.breakpoint('tablet')]: {
            padding: [0 ,theme.spacing.small],
            maxWidth: '100%'
        },
        [theme.breakpoint('laptop')]: {
            maxWidth: ({item: {items}}) => items[0].image_size ? items[0].image_size : '100%'
        }
    }
}))(ImageWithQuoteCarousel)


// WEBPACK FOOTER //
// ./src/components/Article/ImageWithQuoteCarousel.js